// @flow
// material-ui
import {Grid, Stack, Typography} from '@mui/material';

// project imports
import MainCard from "../../../theme/mantis/components/mainCard";

// ==============================|| REPORT CARD ||============================== //

const ReportCard = ({primary, secondary, iconPrimary, color, symbol}) => {
    const IconPrimary = iconPrimary;
    const primaryIcon = iconPrimary ? <IconPrimary fontSize="large"/> : null;

    return (
        <MainCard sx={{ boxShadow:'0px 0px 5px 1px #CAD1E5', borderBottom: '2px solid #0BC1B6'}}>
            <Grid container
                  sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      gap: '10px',
                      flex: '1 0 0'
                  }}
            >
                <Grid item xs={12}>
                    <Typography variant="h2" style={{color}}>
                        {primaryIcon}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Stack spacing={1}>
                        <Typography className='color-secondary p-sm' sx={{maxWidth:'100px'}}>
                          {secondary}
                        </Typography>
                        <Typography className='p-lg-bold color-default'>{primary}{symbol}</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ReportCard;
